export default __webpack_public_path__ + "static/15-e43660c6d8a9ea9d83654f627eb91e71.webp";